import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

import { BOARD_LIMIT } from '@/entities/board';
import { useBoardsListData } from '@/features/boards/ui/save-to-boards/hooks';
import { BoardsHeader } from './header';
import { BoardsListTable } from './list-table';
import { requestCreateBoardDialog } from './overlays/request-create-board-dialog';

export function BoardsListSection() {
  const navigate = useNavigate({ from: '/workspace/$workspaceId/boards' });
  const { boards, createList, isLoading } = useBoardsListData();

  const handleCreateList = async (title: string) => {
    const result = await createList(title);
    if (!result.ok) {
      toast.error(result.reason);
      throw new Error(result.reason);
    }
    toast.success('Board created');
  };

  const handleClickNewBoard = async () => {
    if (boards.length >= BOARD_LIMIT) {
      toast.error(`You can create up to ${BOARD_LIMIT} boards.`);
      return;
    }

    await requestCreateBoardDialog({ onCreate: handleCreateList });
  };

  const handleOpenBoard = (boardId: string) => {
    navigate({
      to: '/workspace/$workspaceId/boards/$boardId',
      params: { boardId },
    });
  };

  return (
    <div className="flex h-full flex-col">
      <BoardsHeader
        listCount={boards.length}
        listLimit={BOARD_LIMIT}
        onClickNewList={handleClickNewBoard}
        showNewBoardButton={boards.length > 0}
      />
      <div className="flex flex-1 flex-col gap-6 overflow-auto p-6">
        <section className="h-full space-y-3">
          <BoardsListTable
            boards={boards}
            isLoading={isLoading}
            onOpenBoard={handleOpenBoard}
            onCreateBoardClick={handleClickNewBoard}
          />
        </section>
      </div>
    </div>
  );
}
